const htmlExportUtil = {
    sanitizeBase64 (base64String) {
        if(!base64String)
            return  null
        return base64String.replace(/^data.*?base64,/, '')
    },

    copyStyle: function (sourceElem, destElem) {
        const computedStyles = window.getComputedStyle(sourceElem)

        Array.from(computedStyles).forEach(propName => {
            if (htmlExportUtil.defaultStyle[propName] !== computedStyles[propName])
                destElem.style.setProperty(
                    propName,
                    computedStyles.getPropertyValue(propName),
                    computedStyles.getPropertyPriority(propName)
                )
        })

        if (sourceElem.children && sourceElem.children.length > 0)
            for (let i = 0; i < sourceElem.children.length; i++)
                this.copyStyle(sourceElem.children[i], destElem.children[i])
    },

    cleanup: function (element) {
        const hideClasses = ['pressure_tests_annotation__actions']

        for (let clazz of hideClasses) {
            const nodeList = element.getElementsByClassName(clazz)

            if (nodeList.length > 0) {
                nodeList[0].innerHTML = ''
                nodeList[0].style.setProperty('display', 'none')
            }
        }
    },

    extractHtml: function (fullWidget) {
        const domCopy = fullWidget.cloneNode(true)

        this.copyStyle(fullWidget, domCopy)

        let nodeList = domCopy.getElementsByClassName('time-range__begin')

        if (nodeList.length > 0) {
            nodeList[0].style.setProperty('width', '')
            nodeList[0].style.setProperty('bottom', '')
            nodeList[0].style.setProperty('top', '10px')
        }

        nodeList = domCopy.getElementsByClassName('time-range__end')
        if (nodeList.length > 0) {
            nodeList[0].style.setProperty('width', '')
            nodeList[0].style.setProperty('bottom', '')
            nodeList[0].style.setProperty('top', '0px')
        }

        nodeList = domCopy.getElementsByClassName('time-range__text')
        if (nodeList.length > 0) nodeList[0].style.setProperty('width', '')

        this.cleanup(domCopy)

        const htm = `<html><head>
            <meta charset="utf-8"/><meta http-equiv="Content-Type" content="text/html; charset=utf-8"/>
            </head><body>
            ${domCopy.outerHTML}
            </body></html>`

        return htm
    }
}

const dummyElement = document.createElement('element-' + new Date().getTime())

document.body.appendChild(dummyElement)
htmlExportUtil.defaultStyle = window.getComputedStyle(dummyElement)

module.exports = htmlExportUtil
